import { Link } from "react-router-dom";
import { GlassCard } from "@/components/common/GlassCard";
import { Button } from "@/components/ui/button";
import { INTEGRATIONS } from "@/lib/integrations";

export function OrgIntegrationsPage() {
  return (
    <section className="space-y-6 p-6 md:p-8">
      <div>
        <p className="text-xs uppercase tracking-[0.14em] text-[#7c3aed] dark:text-violet-300/80">Organization</p>
        <h1 className="mt-1 text-2xl font-semibold text-[var(--lm-foreground-strong)] dark:text-white">Integrations</h1>
        <p className="mt-2 text-sm text-[var(--lm-muted)] dark:text-slate-400">
          Connect organization-managed services and shared sources your team can use across apps.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {INTEGRATIONS.map((integration) => {
          const Icon = integration.icon;

          return (
            <GlassCard key={integration.id} className="flex flex-col gap-4 p-6">
              <div className="flex items-start gap-3">
                <div className="rounded-xl bg-[var(--primary-soft-bg)] p-3 text-[#7c3aed] dark:bg-violet-500/15 dark:text-violet-300">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                  <h2 className="text-lg font-semibold text-[var(--lm-foreground-strong)] dark:text-white">{integration.name}</h2>
                  <p className="mt-1 text-sm text-[var(--lm-muted)] dark:text-slate-400">{integration.description}</p>
                </div>
              </div>

              <div className="mt-auto flex justify-end">
                {integration.status === "available" ? (
                  <Button variant="accent" size="sm" asChild>
                    <Link to={integration.path}>Manage</Link>
                  </Button>
                ) : (
                  <span className="rounded-full border border-[var(--lm-border-subtle)] bg-[var(--surface-sunken)] px-3 py-1 text-xs text-[var(--lm-muted)] dark:border-white/10 dark:bg-slate-900/50 dark:text-slate-500">
                    Coming soon
                  </span>
                )}
              </div>
            </GlassCard>
          );
        })}
      </div>
    </section>
  );
}
